import type { Route } from '../../routes/types';
import { Ingreso } from './acceso/Ingreso';
import { Recuperar } from './acceso/Recuperar';
import { Registro } from './acceso/Registro';
import { RegistroProfesional } from './acceso/RegistroProfesional';
import { Inicio, Portada } from './Inicio';
import { Perfil } from './Perfil';
import { Planes } from './Planes';
import { Resultados } from './Resultados';
import './publico.css';

export const routes: Route[] = [
  { path: '/login', title: 'Ingresar', screen: Ingreso, layout: 'acceso' },
  { path: '/registro', title: 'Crear cuenta', screen: Registro, layout: 'acceso' },
  { path: '/registro-profesional', title: 'Sumá tu consultorio', screen: RegistroProfesional, layout: 'acceso' },
  { path: '/recuperar', title: 'Recuperar el acceso', screen: Recuperar, layout: 'acceso' },
  { path: '/', title: 'Turnos con profesionales verificados', screen: Portada, layout: 'publico', fullWidth: true },
  { path: '/inicio', title: 'Inicio', screen: Inicio, layout: 'publico', fullWidth: true },
  { path: '/buscar', title: 'Buscar profesionales', screen: Resultados, layout: 'publico' },
  { path: '/resultados', title: 'Buscar profesionales', screen: Resultados, layout: 'publico' },
  { path: '/profesional/:id', title: 'Perfil del profesional', screen: Perfil, layout: 'publico' },
  { path: '/planes', title: 'Planes y precios', screen: Planes, layout: 'publico' },
];
